var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"radio-button",class:{checked: _vm.checked},attrs:{"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"13","cy":"13","r":"11.5","stroke":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }